<div class="metadata-container scrollbar">
  <div *ngFor="let metadataItem of metadataList"
      class="metadata-item"
      [class.item-selected]="metadataItem.selected === true"
      (click)="onMetaDataItemClick(metadataItem.key)"
      >
      <div class="text-container">
        {{ metadataItem.value }}
      </div>
  </div>
</div>